import { gql } from '@apollo/client';

/** The home page's track record panel: the queries the old MarketingTiles ran, in one request. */
export const GET_TRACK_RECORD = gql`
  query GetHomeTrackRecord($analysisTypeId: Float = 1, $timePeriod: String = "1_MONTH") {
    topPickStatsByTrackType(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      byTrackType {
        trackType
        winners
        races
        winPercentage
      }
      totalWinners
      totalRaces
      overallWinPercentage
    }
    totalWinnersStatsByTrackType(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      byTrackType {
        trackType
        winners
        races
        winPercentage
      }
      totalWinners
      totalRaces
    }
    trackWithMostWinners(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      trackName
      winners
      races
      winPercentage
    }
    trackWithBestValueROI(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      trackName
      trackCode
      state
      meetingDate
      winners
      races
      roi
    }
    quaddieStats(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      successfulQuaddies
      totalMeetingsAnalyzed
      successPercentage
    }
    earlyQuaddieStats(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      successfulEarlyQuaddies
      totalMeetingsAnalyzed
      successPercentage
    }
    trackWithBestROI(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      trackName
      trackCode
      state
      meetingDate
      winners
      races
      roi
    }
    averageWinnerSP(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      averagePrice
      totalWinners
    }
    biggestWinner(analysisTypeId: $analysisTypeId, timePeriod: $timePeriod) {
      horseName
      trackName
      trackCode
      state
      meetingDate
      raceNumber
      date
      price
    }
    consensusPickStats(timePeriod: $timePeriod) {
      rows {
        trackType
        agreeRaces
        agreeWins
        agreeStrikePct
        m1StrikePct
      }
    }
  }
`;

/** One race day's agreement-mark results (the "<mark> Winners" line in Today so far). */
export const GET_DAY_AGREEMENT = gql`
  query GetDayAgreement($date: String!) {
    consensusPickStats(date: $date) {
      rows {
        trackType
        agreeRaces
        agreeWins
        agreeRoi
      }
    }
  }
`;
